import { NextPage } from 'next';
import dynamic from 'next/dynamic';

const MarketPagesContent = dynamic(() => import(/* webpackChunkName: "market-page" */ '@ping/pages/markets/page'), {
  ssr: false,
}) as () => JSX.Element;

const Market: NextPage = () => <MarketPagesContent />;

export default Market;
